import React from 'react';
import { SaveDiskLined } from '@tag/tag-icons';

import styles from './save-button.module.scss';

export default function AgGridSaveButton() {

  return (
    <div className={styles['save-button']}>
      <SaveDiskLined />
    </div>
  );
}
